import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import PerformanceReviewReview from './PerformanceReviewReview';
import Employee from 'main/stores/employees/Employee';
import _ from 'lodash';
import {calendarDate} from 'shared/tools';
import {auth} from 'main/tools';
import PerformanceReviewCycle from './PerformanceReviewCycle';

class PerformanceReviewReviewee extends DomainObject {
  id;
  reviews = [];
  employee;
  reviewManagerEmployees = [];
  reviewers;
  dueDate;
  launchDate;
  scheduled;
  cycle;

  _relations = {
    employee: Employee,
    reviewManager: Employee,
    reviewManagerEmployees: [Employee],
    reviews: [PerformanceReviewReview],
    reviewers: [Employee],
    cycle: PerformanceReviewCycle,
    _dates: ['dueDate', 'launchDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      reviews: observable,
      employee: observable,
      reviewManagerEmployees: observable,
      reviewers: observable,
      dueDate: observable,
      launchDate: observable,
      scheduled: observable,
      cycle: observable,
      dueDateView: computed,
      launchDateView: computed,
      currentEmployeeManagerReview: computed,
      managerReview: computed,
      peerReviews: computed,
      managerReviewer: computed,
      peerReviewers: computed,
      selfReview: computed,
      selfReviewer: computed,
      selfAndPeerReviewers: computed,
      writeReviewsPath: computed
    });

    this.merge(other);
  }

  get dueDateView() {
    return calendarDate(this.dueDate);
  }

  get launchDateView() {
    return calendarDate(this.launchDate);
  }

  get currentEmployeeManagerReview() {
    return _.find(this.reviews, (review) =>
      review.isManagerReview && review.reviewer?.id == auth.employee.id
    );
  }

  get managerReview() {
    return _.find(this.reviews, r => r.type.kind === 'manager');
  }

  get peerReviews() {
    return _.chain(this.reviews)
      .filter(r => r.type.kind === 'peer')
      .value();
  }

  get managerReviewer() {
    return _.get(this.managerReview, 'reviewer');
  }

  get peerReviewers() {
    return _.map(this.peerReviews, 'reviewer');
  }

  get selfReview() {
    return _.find(this.reviews, r => r.type.kind === 'self');
  }

  get selfReviewer() {
    return _.get(this.selfReview, 'reviewer') || [];
  }

  get selfAndPeerReviewers() {
    return _.concat(this.selfReviewer, this.peerReviewers);
  }

  get writeReviewsPath() {
    return `/reviewees/${this.id}/employee/${this.employee.id}/${this.employee.urlSlug}`;
  }
}

export default PerformanceReviewReviewee;
